import { HTTP } from '@/utils/http-common'
import QueryService from '../Dashboards/services/QueryService'
import DatasetService from '../../Datastore/services/DatasetService'
import FunctionService from '../../Functions/services/FunctionService'
import _ from 'lodash'
export default {
    list (parent) {
        return HTTP.get('/projects/manage/').catch((error) => {
            parent.$store.commit('push', { msg: 'Error ' + error.response.data, color: 'error' })
        })
    },
    get (parent, id) {
        return HTTP.get(`/projects/manage/${id}/`).catch((error) => {
            parent.$store.commit('push', { msg: 'Error ' + error.response.data, color: 'error' })
        })
    },
    delete (parent, id) {
        return HTTP.delete(`/projects/manage/${id}/`, {}).catch((error) => {
            parent.$store.commit('push', { msg: 'Error ' + error.response.data, color: 'error' })
        })
    },
    createOrUpdate (parent, project) {
        if (project.id) {
            return new Promise((resolve, reject) => {
                return HTTP.put(`/projects/manage/${project.id}/`, project).then(r => resolve(r)).catch((error) => {
                    parent.$store.commit('push', {
                        msg: 'Error :  \n' + _.join(_.map(error.response.data, (e) => { return `* ${_.join(e, '\n* ')}` }), '\n'),
                        color: 'error',
                    })
                    return reject(error)
                })
            })
        } else {
            return new Promise((resolve, reject) => {
                return HTTP.post('/projects/manage/', project).then(r => resolve(r)).catch((error) => {
                    parent.$store.commit('push', {
                        msg: 'Error :  \n' + _.join(_.map(error.response.data, (e) => { return `* ${_.join(e, '\n* ')}` }), '\n'),
                        color: 'error',
                    })
                    return reject(error)
                })
            })
        }
    },
    async cloneObject (parent, type, obj) {
        console.log('cloning object', type, obj)
        const projects = await this.list(parent).then(r => {
          return _.map(r.data.results, 'name')
        })
        parent.$store.commit('confirm', {
          message: 'Do you really want to clone this ' + type + ' ?',
          title: 'Warning',
          color: 'warning',
          form: {
            clone_name: {
              type: 'text',
              label: 'New ' + type + ' name',
              placeholder: 'New ' + type + ' name',
            },
            target_project: {
              type: 'select',
              values: projects,
              label: 'Target project',
              placeholder: 'Choose a target project',
              required: true,
            },
          },
          onCancel: () => {},
          onConfirm: (args) => {
            this.list(parent).then((result) => {
                // Retrieve project id
                let myPg = _.pickBy(result.data.results, { name: args.target_project })
                if (Object.keys(myPg).length > 0) {
                  myPg = myPg[Object.keys(myPg)[0]].id
                  switch (type) {
                  case 'query':
                      return QueryService.clone(parent, obj, myPg, args.clone_name).then((result) => {
                          parent.getProject()
                          return result
                      })
                  case 'dataset':
                      return DatasetService.clone(parent, obj, myPg, args.clone_name).then((result) => {
                          parent.getProject()
                          return result
                      })
                  case 'function':
                      return FunctionService.clone(obj, parent, myPg, args.clone_name).then((result) => {
                          parent.getProject()
                          return result
                      })
                  default:
                      console.log(`cloneObject type unrecognized ${type}`)
                      break
                  }
                }
              })
          },
        })
    },
    changePermission (parent, project, user, permission) {
        HTTP.post('permissions/project/' + project.id + '/', {
            username: user,
            perms: permission,
        }).then((response) => {
            parent.$store.commit('push', { msg: 'Permissions updated', color: 'success' })
            parent.$emit('modifyPermissions', { type: 'changePermission', user: user, permission: permission })
        }).catch((error) => {
            if (error.response.status === 404) {
                parent.$store.commit('push', { msg: 'Username does not exist', color: 'error' })
            } else {
                parent.$store.commit('push', { msg: 'error ' + error.response.status + ' in ProjectService.js @changePermission', color: 'error' })
                console.log('error ' + error.response.status + ' - refer to this file and line --->')
            }
        })
    },
    deletePermission (parent, project, user) {
        HTTP.delete('permissions/project/' + project.id + '/username/' + user.username + '/')
            .then((response) => {
                parent.$store.commit('push', { msg: 'Permission deleted', color: 'success' })
                parent.$emit('modifyPermissions', { type: 'deletePermission', user: user })
            }).catch((error) => {
                parent.$store.commit('push', { msg: 'Error when deleting the user\'s permissions', color: 'error' })
                console.log('error ' + error.response.status + ' - refer to this file and line --->')
            })
    },
}
